import React from 'react'
import PropTypes from 'prop-types'

import StarFullIcon from '../../../components/icons/starFull'
import StarHalfEmptyIcon from '../../../components/icons/starHalfEmpty'
import StarEmptyIcon from '../../../components/icons/starEmpty'

const StarRating = ({
  rating,
  className,
  fullStarClass = 'star-rating__star--full',
  halfStarClass = 'star-rating__star--half',
  emptyStarClass = 'star-rating__star--empty',
  maxStars = 5
}) => {
  let stars = []
  let roundedRating = Math.round(rating * 2) / 2.0
  for (let i = 0; i < Math.floor(roundedRating); i++) {
    stars.push(StarFullIcon)
  }

  if (roundedRating % 1) {
    stars.push(StarHalfEmptyIcon)
  }

  while (stars.length < maxStars) {
    stars.push(StarEmptyIcon)
  }

  const IconStyles = {
    color: '#fec42d'
  }

  return (
    <div className={className}>
      {stars.map((Icon, index) => <Icon style={IconStyles} key={index} />)}
    </div>
  )
}

StarRating.propTypes = {
  rating: PropTypes.number.isRequired,
  className: PropTypes.string,
  fullStarClass: PropTypes.string,
  halfStarClass: PropTypes.string,
  emptyStarClass: PropTypes.string,
  maxStars: PropTypes.number
}

export default StarRating



// WEBPACK FOOTER //
// ./client/pages/search/result/starRating.js